import { useState } from 'react';
import Button from '@alltrails/shared/denali/components/Button';
import Slider from '@alltrails/shared/components/sliders/Slider';
import ArrowSq from '@alltrails/shared/icons/ArrowSq';
import Lock from '@alltrails/shared/icons/Lock';
import Pause from '@alltrails/shared/icons/Pause';
import RotateLeft from '@alltrails/shared/icons/RotateLeft';
import ScenicDriving from '@alltrails/shared/icons/ScenicDriving';
import { useFlyoverSettings } from 'components/MapProvider';
import useFeatures from 'hooks/useFeatures';

import * as styles from './styles.module.scss';

export type FlyoverMapControlsProps = {
  enable3D: () => void;
  terrainActive: boolean;
};

const FlyoverMapControls = ({ enable3D, terrainActive }: FlyoverMapControlsProps): JSX.Element => {
  const features = useFeatures();

  const {
    didMapLoadEventsFire,
    flyoverLoadingState,
    initFlyover,
    isPaused,
    resetAnimation,
    setAnimationDuration,
    toggleCameraLock,
    togglePauseFlyover
  } = useFlyoverSettings();

  const [durationIndex, setDurationIndex] = useState(4);
  const sliderOptions = [{ label: 0.6 }, { label: 0.7 }, { label: 0.8 }, { label: 0.9 }, { label: 1 }];
  const updateDuration = (index: number) => {
    setDurationIndex(index);
    setAnimationDuration(sliderOptions[index].label);
  };

  if (!features.includes('trail_flyover') || !didMapLoadEventsFire) {
    return null;
  }

  // TODO: more checks around whether 3D is available for the current layer
  if (flyoverLoadingState === 'notStarted') {
    return (
      <div className={styles.controlsContainer}>
        <Button
          icon={{ Component: ScenicDriving }}
          onClick={() => initFlyover(terrainActive, enable3D)}
          size="sm"
          testId=""
          text="Flyover" // TODO: TRAILS-713 localization
          width="full"
        />
      </div>
    );
  }

  // TODO: TRAILS-713 localization
  return (
    <div className={styles.controlsContainer}>
      <Button
        icon={{ Component: isPaused ? ArrowSq : Pause }}
        onClick={togglePauseFlyover}
        size="sm"
        testId=""
        text={isPaused ? 'Play' : 'Pause'}
        variant="primary"
        width="full"
      />
      <Button icon={{ Component: RotateLeft }} onClick={resetAnimation} size="sm" testId="" text="Reset" width="full" />
      <Button icon={{ Component: Lock }} onClick={toggleCameraLock} size="sm" testId="" text="Lock camera" width="full" />
      <Slider onChange={updateDuration} options={sliderOptions} selectedIndex={durationIndex} title="Speed" />
    </div>
  );
};

export default FlyoverMapControls;
